import { useEffect } from 'react';

/**
 * Sperrt das Scrollen der Seite, solange `isLocked` gilt (Menue, Modal).
 *
 * Zwei Wege, weil zwei Scroller existieren: In der App scrollt `body`
 * (index.css: html/body height:100% + overflow-y:auto) — dort reicht das
 * Inline-Style. Auf den oeffentlichen Seiten scrollt das Dokument und
 * `html.landing-page-html body { overflow-y: visible !important }` schlaegt
 * jedes Inline-Style; dafuer setzt der Hook zusaetzlich `scroll-lock` an
 * <html> (Regel in index.css, ebenfalls !important).
 */
// Zaehler statt Ja/Nein: Ein Modal ueber dem Menue darf beim Schliessen die
// Sperre des Menues nicht mit aufheben.
let locks = 0;

export const useBodyScrollLock = (isLocked) => {
  useEffect(() => {
    if (!isLocked) return undefined;
    locks += 1;
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('scroll-lock');
    return () => {
      locks = Math.max(0, locks - 1);
      if (locks === 0) {
        document.body.style.overflow = '';
        document.documentElement.classList.remove('scroll-lock');
      }
    };
  }, [isLocked]);
};
